import { cn } from '@/lib/utils'

/**
 * Сайтын бүх хэсгийн НЭГ өргөн.
 *
 * Өмнө нь хоёр өөр хэмжээ зэрэг ажиллаж байсан: өөрсдийн section-ууд
 * `container` (2xl дээр 1536px), худалдаж авсан блокууд `max-w-7xl` (1280px).
 * Толгой ба хөлийн хэсэг нь `container` дээр байсан тул блокуудын агуулга
 * цэсний доор 128px-ээр дотогшоо орж, мөр бүр өөр өөр газраас эхэлдэг байв.
 *
 * Хэвтээ зайг мөн энд төвлөрүүлэв — өргөн нь таарч, зай нь зөрвөл ирмэг
 * дахин л зөрнө.
 */
export const SITE_CONTAINER = 'container mx-auto px-4 sm:px-6 lg:px-8'

/**
 * Хэсэг хоорондын НЭГ хэмнэл.
 *
 * ! Өмнө нь хэсэг бүр өөрийн зайтай байв: өөрсдийн блокууд `py-20`, үнэт
 * ! зүйлс `py-14`, худалдаж авсан блокууд `py-8 sm:py-16 lg:py-24`,
 * ! галерей `py-8 sm:py-12`. Хэсгийн доод зураас байхад зөрүү нь нуугдаж
 * ! байсан ч түүнийг хассны дараа нэг хуудсан дээр 40px-ээс 112px хүртэл
 * ! янз бүрийн завсар зэрэгцэж, хэмнэл алдагдсан.
 */
export const SECTION_PADDING = 'py-16 sm:py-20 lg:py-24'

export const Container = ({ className, children }: { className?: string; children: React.ReactNode }) => (
  <div className={cn(SITE_CONTAINER, className)}>{children}</div>
)
